import { Box } from "atomic-layout"
import * as React from "react"
import styled from "styled-components"
import Button from "../../atoms/Button"
import Container from "../../atoms/Container"
import {query} from "atomic-layout"
import {responsiveFontSize} from "../../../utils/typography"

const StyledBlueBox = styled.div`
position: absolute;
  width: 100%;
  height: calc(50% + 37px);
  left: 0;
  right: 0;
  bottom: -37px;  
  background-color: #0076A8;
  padding-bottom: 37px;
`

const StyledCallout = styled(Box)`
  position: relative;
  z-index: 2;
  padding: 24px;
  color: #fff;
  background-color: #003057;
  border: 8px solid #fff;
  text-align: center;

  @media ${query({to: "md"})}{
    h2{
      ${responsiveFontSize(2, 1)}
    }
  }

  @media ${query({from: "lg"})}{
    padding: 80px 2rem;
  }
  
  .callout-text{
    max-width: 590px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: var(--paragraph-margin-block-end);
  }
`

const Callout = ({
                   heading = null,
                   text = null,
                   primaryButtonText = "",
                   primaryButtonUrl = {},
                   secondaryButtonText = "",
                   secondaryButtonUrl = {}
                 }) =>
  (
    <Container fluid={true}>
      <StyledBlueBox/>
      <Container>
      <StyledCallout>
        {heading}
        
        <div className={'callout-text'}>
          {text}  
        </div>
        
        {primaryButtonText &&
        <Button to={primaryButtonUrl?.url} target={primaryButtonUrl?.target} outline>{primaryButtonText}</Button>
        }
        {secondaryButtonText &&
        <Button to={secondaryButtonUrl?.url} target={secondaryButtonUrl?.target} secondary style={{
          fontSize: 18,
          whiteSpace: "nowrap"
        }}>{secondaryButtonText}</Button>
        }
      </StyledCallout>
      </Container>
    </Container>
    
  )

export default Callout
